import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { DefaultDateBehavior } from "./DefaultDateBehavior";
import { Age } from "../../../patient";

/** HIS項目患者年齢を生成する */
export class PtAgeBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_AGE";
  private static readonly PtBirthDateKey = "PT_BIRTHDATE";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtAgeBehavior.Key).map(x => x.value);
    const behavior = new DefaultDateBehavior(PtAgeBehavior.PtBirthDateKey);
    const values = behavior.getValue(hisInfoItems).data as Date[];
    const today = new Date();
    const age = values.map(x => Age.calculate(x, today)).map(formatAge);
    const data = itemValues.length > 0 ? itemValues : age;
    return new HisInformationTextValue(PtAgeBehavior.Key, data);
  }
}

function formatAge(age: Age): string {
  return age.year.toString();
}
